import { useTranslation } from 'react-i18next';
import { Flex, Typography } from 'antd';

import themeToken from '@lib/theme/tokens/index';
import RenameIcon from '@/components/Icons/RenameIcon';

import { StyledActionIconContainer } from './StyledActionIconContainer';
import { useTrackEvent } from '@/hooks/useTrackEvents';

const { Text } = Typography;

type Props = {
  disabled: boolean;
  isWhiteBgColor?: boolean;
  hasLabel?: boolean;
  isVertical?: boolean;
  setSelectedFile?: () => void;
  setIsEditModalOpen: () => void;
  closeDropdown?: () => void;
};

const EditFile = ({
  disabled,
  closeDropdown,
  setIsEditModalOpen,
  setSelectedFile,
  hasLabel = true,
  isWhiteBgColor = false,
  isVertical = true,
}: Props) => {
  const { sendMixpanelEvent } = useTrackEvent({ page: 'dataroom' });
  const { t } = useTranslation('dataroom');

  return (
    <Flex
      onClick={(e) => {
        e.stopPropagation();
        if (disabled) return;
        sendMixpanelEvent('edit-file-btn-clicked');
        setSelectedFile?.();
        setIsEditModalOpen();
        closeDropdown?.();
      }}
      vertical={isVertical}
      align="center"
      gap={isVertical ? 2 : 8}
      style={{ cursor: !disabled ? 'pointer' : 'not-allowed' }}
    >
      <StyledActionIconContainer isWhiteBgColor={isWhiteBgColor} isVertical={isVertical}>
        <RenameIcon width={18} height={18} fill="#2A186A" />
      </StyledActionIconContainer>
      {hasLabel && (
        <Text
          style={{
            color: themeToken['branding-primary-3'],
            fontSize: themeToken.fontSizeSM,
            fontWeight: 400,
          }}
        >
          {t('rename')}
        </Text>
      )}
    </Flex>
  );
};

export default EditFile;
